import { render, staticRenderFns } from "./PlanningCollaborative.vue?vue&type=template&id=03f0ba40&scoped=true"
import script from "./PlanningCollaborative.vue?vue&type=script&lang=js"
export * from "./PlanningCollaborative.vue?vue&type=script&lang=js"
import style0 from "./PlanningCollaborative.vue?vue&type=style&index=0&id=03f0ba40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0ba40",
  null
  
)

export default component.exports